import Measurer from "../Measurer";
import RFAbstract from "./RFAbstract";
import Bohrlochleiste from "../../arrangement/Bohrlochleiste";
import Fit from "../Fit";

export default class RFInterieurBohrlochleiste extends RFAbstract {

    constructor(interactionHandler) {
        super(interactionHandler);
    }

    getRestraints() {
        const interieur = this.dragObject3d.vsData;
        const ranges = [];
        APP.arrangement.iterateElements(element => {
            if (interieur.acceptElement(element)) {
                const fits = new Measurer(Measurer.CENTER).getInterieurYFits(interieur, element);
                const bohrlochleiste = Bohrlochleiste.createBohrlochleiste(element, interieur.bohrlochleiste);
                const bohrlochYs = bohrlochleiste.getBohrlochYSchrankPositions();
                const allowedYs = bohrlochYs.filter(y => fits.some(fit => fit.contains(y)));

                const allowedFits = allowedYs.map(y => {
                    const fit = new Fit();
                    fit.minCollapse = fit.min = fit.max = fit.maxCollapse = y;
                    return fit;
                });
                const box = element.localToSchrankBox(interieur.getElementBox(element));
                allowedFits.forEach(fit=>ranges.push({fit, element, box}));
            }
        });

        let restraints = this._mapFitsToRestraints(ranges, {});

        return this._addRoomAndRemoveRestraints(restraints);
    }

}
